import { render, staticRenderFns } from "./CompactEventBlock.vue?vue&type=template&id=ca45192c&"
import script from "./CompactEventBlock.vue?vue&type=script&lang=js&"
export * from "./CompactEventBlock.vue?vue&type=script&lang=js&"
import style0 from "./CompactEventBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports